import { render, staticRenderFns } from "./PracticePart1Edit.vue?vue&type=template&id=7b588cdf&"
import script from "./PracticePart1Edit.vue?vue&type=script&lang=ts&"
export * from "./PracticePart1Edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports